/**
 * §9.6 Partnership Opportunities — 5 partnership category cards.
 */

import React from 'react'
import {
  Cpu, Handshake, GraduationCap, Puzzle, Compass, Sparkles, ArrowRight,
} from 'lucide-react'
import {
  Container, Eyebrow, SectionHeading, GhostButton,
} from '@/components/landing/design-system'
import { PARTNERSHIPS } from '../data'
import { TONE } from '../_shared'

const ICONS = { Cpu, Handshake, GraduationCap, Puzzle, Compass }

export default function Partnerships() {
  return (
    <section id="partnerships" className="relative py-24 md:py-28 scroll-mt-24">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow tone="green">Partnership Opportunities</Eyebrow>
          <SectionHeading align="center"
            title={<>Five collaboration models{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">that already work.</span></>}
            subtitle="Kalki Ai Cloud grows through partners — reseller channels, integration builders, education programmes and long-horizon strategic alliances."
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 md:gap-4">
          {PARTNERSHIPS.map((p) => {
            const tone = TONE[p.tone] || TONE.orange
            const Icon = ICONS[p.iconKey] || Sparkles
            return (
              <div key={p.id} className="relative rounded-2xl border border-white/10 bg-white/[0.02] p-5 backdrop-blur-xl transition-all hover:border-white/20 hover:bg-white/[0.03] overflow-hidden flex flex-col gap-3">
                <div className="pointer-events-none absolute inset-0 opacity-40"
                  style={{ background: `radial-gradient(80% 45% at 20% 0%, rgba(${tone.rgb},0.12), transparent 70%)` }} />
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border"
                  style={{ borderColor: `rgba(${tone.rgb},0.35)`, background: `rgba(${tone.rgb},0.08)`, color: tone.hex }}>
                  <Icon strokeWidth={1.8} style={{ width: 18, height: 18 }} />
                </span>
                <div className="relative">
                  <h4 className="text-[14.5px] font-semibold text-white leading-tight">{p.label}</h4>
                  <p className="text-[12.5px] text-zinc-400 leading-relaxed mt-1.5">{p.body}</p>
                </div>
              </div>
            )
          })}
        </div>

        <div className="rounded-3xl border border-white/10 bg-gradient-to-br from-white/[0.03] to-white/[0.01] p-5 md:p-6 backdrop-blur-xl overflow-hidden relative">
          <div className="pointer-events-none absolute inset-0 opacity-70"
            style={{ background: 'radial-gradient(60% 40% at 20% 0%, rgba(168,85,247,0.10), transparent 70%)' }} />
          <div className="relative flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="flex-1">
              <div className="text-[15px] font-semibold text-white leading-tight">Interested in becoming a partner?</div>
              <p className="text-[13px] text-zinc-400 leading-relaxed mt-1">Tell us about your business, your customer base and the collaboration model you have in mind — we&apos;ll come back with a tailored proposal.</p>
            </div>
            <GhostButton href="#sales" trailingIcon>
              Discuss partnership <ArrowRight className="h-3 w-3" />
            </GhostButton>
          </div>
        </div>
      </Container>
    </section>
  )
}
